export const TEMPLATE_TYPE: Readonly<{
  MESSAGE: 'MESSAGE';
  SURVEY: 'SURVEY';
}> = Object.freeze({
  MESSAGE: 'MESSAGE',
  SURVEY: 'SURVEY',
});
